'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liftState = exports.loop = exports.getModel = exports.getEffect = exports.getCmd = exports.isLoop = undefined;

var _utils = require('./utils');

var _cmd = require('./cmd');

var _cmd2 = _interopRequireDefault(_cmd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isLoop = exports.isLoop = function isLoop(array) {
  return Array.isArray(array) && array.length === 2 && (0, _cmd.isCmd)(array[1]);
};

var getCmd = exports.getCmd = function getCmd(loop) {
  return isLoop(loop) ? loop[1] : null;
};

var getEffect = exports.getEffect = function getEffect(loop) {
  console.warn('getEffect is deprecated. Please\n    use getCmd (https://github.com/redux-loop/redux-loop/blob/master/docs/ApiDocs.md#getcmdloop-cmd--null).\n    getEffect will be removed in the next major version.');

  return getCmd(loop);
};

var getModel = exports.getModel = function getModel(loop) {
  return isLoop(loop) ? loop[0] : loop;
};

var loop = exports.loop = function loop(model, cmd) {
  if (process.env.NODE_ENV === 'development') {
    (0, _utils.throwInvariant)((0, _cmd.isCmd)(cmd), 'Given cmd is not an Cmd instance.');
  }

  return [model, cmd];
};

var liftState = exports.liftState = function liftState(state) {
  return isLoop(state) ? state : loop(state, _cmd2['default'].none);
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-loop/lib/loop.js
// module id = 63
// module chunks = 0